import React from 'react';
import ReactDOM from 'react-dom';
import Cropper from 'react-easy-crop';
import 'react-easy-crop/react-easy-crop.css';

/**
 * Modal de recorte de imagen reutilizable.
 * Se monta via Portal en document.body para evitar problemas
 * de z-index, overflow u overflow:hidden en ancestros.
 */
const CropperModal = ({
  rawImageSrc,
  crop, setCrop,
  zoom, setZoom,
  onCropComplete,
  onCancel,
  onApply,
}) => {
  if (!rawImageSrc) return null;

  return ReactDOM.createPortal(
    <div className="crop-overlay">
      <div className="crop-modal">
        <div className="crop-header">
          <h3>Ajusta tu foto de perfil</h3>
          <p>Centra y recorta la imagen a tu gusto</p>
        </div>
        <div className="crop-area">
          <Cropper
            image={rawImageSrc}
            crop={crop}
            zoom={zoom}
            aspect={1}
            cropShape="round"
            showGrid={false}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
          />
        </div>
        <div className="crop-zoom-row">
          <span>Zoom</span>
          <input
            type="range"
            min={1}
            max={3}
            step={0.05}
            value={zoom}
            onChange={(e) => setZoom(Number(e.target.value))}
            className="crop-zoom-slider"
          />
        </div>
        <div className="crop-actions">
          <button type="button" className="crop-btn-cancel" onClick={onCancel}>
            Cancelar
          </button>
          <button type="button" className="crop-btn-apply" onClick={onApply}>
            Aplicar recorte
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CropperModal;
